import { render, staticRenderFns } from "./ValidationRuleEditor.vue?vue&type=template&id=5ac39f66"
import script from "./ValidationRuleEditor.vue?vue&type=script&lang=js"
export * from "./ValidationRuleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports